import React from "react";
import moment from "moment";

import { useNavigate, Link, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import { format } from "date-fns";

import {
  TailwindToaster,
  ConfirmationModal,
  GmapsComponent,
  PropertyThumbnail,
  PropertyTagging,
  numberToINR,
} from "../../components";

import axios from "../../api/axios";
import CryptoJS from "crypto-js";
import { downloadBlobFile, uploadBlobToContainer } from "../../api/azure";

const EnquiryIndividual = () => {
  moment.locale("en-US");
  const state = useSelector((state) => state.UserReducer);
  const { enquiryId } = useParams();
  const enquiryUrl = "/enquiry/";
  const blobContainerName = "serviceticketattachments";
  const enquiryCommentsUrl = "/enquirycomment";
  const tagPifUrl = "/enquiry/remove/pif";

  const navigate = useNavigate();

  const [enquiryCommentsData, setEnquiryCommentsData] = React.useState([]);
  const [enquiryServerData, setEnquiryServerData] = React.useState({});
  const [requestLoading, setRequestLoading] = React.useState(false);
  const [isFileUploading, setIsFileUploading] = React.useState(false);
  const getRefinedBudget = (budgetValue) => {
    if (budgetValue / 10000000 >= 1) return [budgetValue / 10000000, 10000000];
    else if (budgetValue / 100000 >= 1) return [budgetValue / 100000, 100000];
    else return [budgetValue / 1000, 1000];
  };
  const getBudgetFactor = (factor) => {
    switch (factor) {
      case 10000000:
        return "Crores";
      case 100000:
        return "Lakhs";
      default:
        return "Thousands";
    }
  };
  const transformAddress = (item) => {
    const addressString = [
      item.addressline1?.replace(",", " ").trim(),
      item.addressline2?.replace(",", " ").trim(),
      item.city?.replace(",", " ").trim(),
      item.state?.replace(",", " ").trim(),
    ];
    const filtered = addressString.filter((item) => {
      return (
        item &&
        item !== null &&
        item !== undefined &&
        item.toString().trim() !== ""
      );
    });
    if (filtered.join("").trim() !== "") {
      return filtered.join(", ").trim();
    }
    return "";
  };
  const renderStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-xs font-semibold ml-3 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ASSIGNED":
        return (
          <span
            className='bg-orange-100 text-orange-800 text-xs font-semibold ml-3 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'
            title='Assigned to Operations Team'>
            ASSIGNED
          </span>
        );
      case "IN-PROCESS":
        return (
          <span
            className='bg-green-100 text-green-800 text-xs font-semibold ml-3 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'
            title='Assigned to Service Team'>
            IN&nbsp;PROCESS
          </span>
        );
      case "DROPPED":
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold ml-3 px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            DROPPED
          </span>
        );

      default:
        return (
          <span className='bg-red-100 text-orange-800 text-xs font-semibold ml-3 px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            {status?.toUpperCase()}
          </span>
        );
    }
  };
  const renderTags = (tags) => {
    const tagsArray = tags.split(" ");
    var returnText = "";
    tagsArray.forEach((element) => {
      returnText += "#" + element + " ";
    });
    return returnText.trim();
  };

  const getEnquiry = async () => {
    try {
      axios
        .get(enquiryUrl + enquiryId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.enquiry) {
            setEnquiryServerData(response.data.enquiry);
            setPageTitle(
              "Enquiry #" + response.data.enquiry.enquiryID + " - L&L ERP",
            );
            setEnquiryCommentsData(response.data.enquiryCommentsData);
            setMarkerCoordinates({
              lat: response.data.enquiry.pifLat,
              lng: response.data.enquiry.pifLng,
            });
            setPropertyImageAttachments(
              response.data.enquiry.pifPropertyImages,
            );
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [refreshIndex, setRefreshIndex] = React.useState(0);

  const untagProperty = (pifIndex) => {
    try {
      axios
        .put(tagPifUrl + "/" + enquiryId + "/" + pifIndex, JSON.stringify({}), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshIndex(refreshIndex + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const [popupId, setPopupId] = React.useState(null);
  const removeActivity = (enquiryCommentId) => {
    setPopupId(enquiryCommentId);
  };
  const popupCallback = (canProceed) => {
    if (canProceed) removeActivityServer(popupId);
    setPopupId(null);
  };
  const closeConfirmation = () => {
    setPopupId(null);
  };
  const removeActivityServer = (enquiryCommentId) => {
    try {
      axios
        .delete(enquiryCommentsUrl + "/" + enquiryCommentId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);

            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
            getEnquiry();
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [validCommentDescription, setCommentDescriptionValidity] =
    React.useState(true);
  const [commentAttachments, setCommentAttachments] = React.useState([]);

  const uploadCommentAttachments = async (files) => {
    setIsFileUploading(true);
    let latestAttachments = [];
    for (let i = 0; i < files.length; i++) {
      const fileExtension = files[i].name.split(".")[1];
      const blobName =
        CryptoJS.AES.encrypt(
          files[i].name + Date.now().toString(),
          process.env.REACT_APP_CIPHER_CODE,
        )
          .toString()
          .replace(/[^a-zA-Z0-9_]/g, "") +
        "." + // + ".crypt";
        fileExtension;

      const uploadedItem = {
        blobName,
        originalname: files[i].name,
        contentType: files[i].type,
        blobContainerName: "erpmvpblobstorage",
      };
      try {
        // const uploadBlobResult = await uploadBlobToContainer(
        //   blobContainerName,
        //   blobName,
        //   files[i],
        // );
        // if (uploadBlobResult.status === "success") {
        //   const blobItem = {
        //     originalname: files[i].name,
        //     size: files[i].size,
        //     blobContainer: blobContainerName,
        //     blobName,
        //     mimetype: files[i].type,
        //   };
        //   latestAttachments.push(blobItem);
        // }

        const renamedFile = new File([files[i]], blobName, {
          type: files[i].type,
        });
        const formData = new FormData();
        formData.append("file", renamedFile);
        formData.append("blobName", blobName);

        const resp = await axios.post(enquiryCommentsUrl + "/upload", formData);
        if (resp.status === 200) {
          // const uploadedItem = {};
          console.log(uploadedItem);
          latestAttachments.push(uploadedItem);
        } else {
          toast.error("Error uploading file");
        }
      } catch (err) {
        toast.error("Something went wrong");
        console.log(err);
      }
    }
    if (commentAttachments.length > 0)
      setCommentAttachments(commentAttachments.concat(latestAttachments));
    else setCommentAttachments(latestAttachments);
    setIsFileUploading(false);
  };

  const removeCommentAttachment = (serverfilename) => {
    const filteredAttachments = commentAttachments.filter((item) => {
      return item.originalname !== serverfilename;
    });
    setCommentAttachments(filteredAttachments);
  };

  // React.useEffect(() => {
  //   console.log(commentAttachments);
  // }, [commentAttachments]);

  const postComment = (event) => {
    var canSubmit = true;
    const enquiryCommentData = new FormData(event.target);

    setCommentDescriptionValidity(true);

    if (enquiryCommentData.get("commentDescription") === "") {
      setCommentDescriptionValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }
    setRequestLoading(true);
    const dataToSubmit = {
      enquiryId: enquiryId,
      description: enquiryCommentData.get("commentDescription"),
      tags: enquiryCommentData.get("commentTags"),
      commentAttachments,
    };
    try {
      axios
        .post(enquiryCommentsUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            document.getElementById("enquiryCommentForm").reset();
            setCommentAttachments([]);
            // setRefreshData(refreshData + 1);
            setEnquiryCommentsData(response.data.enquiryComments);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setRequestLoading(false);
    }
  };

  const [pageTitle, setPageTitle] = React.useState("Enquiry - L&L ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const [downloadBlobFileName, setDownloadBlobFile] = React.useState(null);

  const downloadAttachment = async (
    blobContainer,
    blobName,
    originalname,
    mimetype,
  ) => {
    try {
      setDownloadBlobFile(blobName);
      // Azure Stuff
      // const azureDownloadresult = await downloadBlobFile(
      //   blobContainer,
      //   blobName,
      //   originalname,
      // );
      // if (azureDownloadresult.status === "success") {
      //   const azureData = azureDownloadresult.data;
      //   const downloadFileUrl = window.URL.createObjectURL(azureData);
      //   const temporaryDownloadLink = document.createElement("a");
      //   temporaryDownloadLink.href = downloadFileUrl;
      //   temporaryDownloadLink.setAttribute("download", originalname);
      //   temporaryDownloadLink.click();
      // } else {
      //   toast.error("Something went wrong with file download");
      // }

      // GCS Stuff
      const response = await axios.get(
        enquiryCommentsUrl + "/download/" + blobName,
        {
          responseType: "blob",
        },
      );
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = originalname;
      link.click();
      setDownloadBlobFile(null);
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [closingAttachments, setClosingAttachments] = React.useState([]);

  const uploadClosingAttachments = async (files) => {
    setIsFileUploading(true);
    let latestAttachments = [];
    for (let i = 0; i < files.length; i++) {
      const fileExtension = files[i].name.split(".")[1];
      const blobName =
        CryptoJS.AES.encrypt(
          files[i].name + Date.now().toString(),
          process.env.REACT_APP_CIPHER_CODE,
        )
          .toString()
          .replace(/[^a-zA-Z0-9_]/g, "") + ".crypt";
      // + fileExtension;
      try {
        const uploadBlobResult = await uploadBlobToContainer(
          blobContainerName,
          blobName,
          files[i],
        );
        if (uploadBlobResult.status === "success") {
          const blobItem = {
            originalname: files[i].name,
            size: files[i].size,
            blobContainer: blobContainerName,
            blobName,
            mimetype: files[i].type,
          };
          latestAttachments.push(blobItem);
        }
      } catch (err) {
        toast.error("Something went wrong");
        console.log(err);
      }
    }
    if (closingAttachments.length > 0)
      setClosingAttachments(closingAttachments.concat(latestAttachments));
    else setClosingAttachments(latestAttachments);
    setIsFileUploading(false);
  };

  const removeClosingAttachment = (serverfilename) => {
    const filteredAttachments = closingAttachments.filter((item) => {
      return item.filename !== serverfilename;
    });
    setClosingAttachments(filteredAttachments);
  };

  const createServiceTicket = () => {
    const closingComments = document.getElementById("closingComments").value;
    const dataToSubmit = {
      closingComments,
      closingAttachments,
      status: "IN-PROCESS",
    };
    setRequestLoading(true);
    try {
      axios
        .put(enquiryUrl + "status/" + enquiryId, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          setRequestLoading(false);
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            navigate(-1);
          } else {
            toast.error(response.data.message);
          }
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [markerCoordinates, setMarkerCoordinates] = React.useState({
    lat: 11.0083592,
    lng: 76.9746159,
  });
  const [propertyImageAttachments, setPropertyImageAttachments] =
    React.useState([]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getEnquiry();
  }, [refreshIndex]);

  return (
    <>
      {popupId && (
        <ConfirmationModal
          actionName={<strong>Delete Activity</strong>}
          deleteConfirmation={popupCallback}
          moduleName={"Delete Activity (irreversible)"}
          itemName={"of Enquiry"}
          closeConfirmation={closeConfirmation}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <TailwindToaster />
                <div className='shadow-lg overflow-hidden sm:rounded-md'>
                  <div className='px-4 py-5 bg-white sm:p-6'>
                    <div className='lg:flex lg:items-center justify-between border-b-2 pb-4 border-gray-100'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <h2 className='text-lg font-semibold text-gray-dark sm:text-lg divider-x'>
                          {enquiryServerData?.enquiryID ? (
                            <p>
                              Enquiry - #{enquiryServerData.enquiryID}
                              {" / "}
                              {enquiryServerData?.leadEnteredDate
                                ?.toString()
                                .slice(0, 10)}
                              {renderStatus(enquiryServerData?.status)}
                            </p>
                          ) : (
                            <span className='mt-1 block w-full py-0  sm:text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-yellow-2 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </h2>
                      </div>
                    </div>
                    <div className='mt-4 sm:mt-4 grid grid-cols-12 gap-6'>
                      <div className='col-span-7 sm:col-span-3'>
                        <label
                          htmlFor='phoneNumber'
                          className={`block text-xs font-semibold text-gray-dark`}>
                          Mobile#
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.addressBookId
                              ? enquiryServerData?.addressBookId?.crm?._id ===
                                "636751da314cd73283ec3671"
                                ? "+" +
                                  enquiryServerData?.addressBookId
                                    ?.countryCode +
                                  " " +
                                  enquiryServerData?.addressBookId?.phoneNumber.slice(
                                    0,
                                    2,
                                  ) +
                                  "XXX XX" +
                                  enquiryServerData?.addressBookId?.phoneNumber.slice(
                                    7,
                                    10,
                                  )
                                : "+" +
                                  enquiryServerData?.addressBookId
                                    ?.countryCode +
                                  " " +
                                  enquiryServerData?.addressBookId?.phoneNumber
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>

                      <div className='col-span-12 sm:col-span-3'>
                        <label
                          htmlFor='lastName'
                          className='block text-xs font-semibold text-gray-dark'>
                          Client Name
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            <Link
                              to={
                                "/addressbook/" +
                                enquiryServerData?.addressBookId?._id
                              }
                              className='cursor-pointer font-semibold'>
                              {enquiryServerData?.addressBookId?.prefix}.&nbsp;
                              {enquiryServerData?.addressBookId?.firstName}
                              &nbsp;
                              {enquiryServerData?.addressBookId?.lastName
                                ? enquiryServerData?.addressBookId?.lastName
                                : ""}
                            </Link>
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-3'>
                        <label
                          htmlFor='customerType'
                          className={`block text-xs font-semibold text-gray-dark}`}>
                          Customer Type
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.addressBookId?.customerType}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-3'>
                        <label
                          htmlFor='leadEnteredBy'
                          className='block text-xs font-semibold text-gray-dark'>
                          Lead Entered By
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.createdBy?.fullname}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-8 sm:col-span-3'>
                        <label
                          htmlFor='serviceTypeId'
                          className={`block text-xs font-semibold text-gray-dark
                          }`}>
                          Service
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.serviceTypeId?.name}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-8 sm:col-span-3'>
                        <label
                          htmlFor='subServiceTypeId'
                          className={`block text-xs font-semibold text-gray-dark
                          }`}>
                          Sub Service
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.subServiceTypeId?.name}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-8 sm:col-span-3'>
                        <label
                          htmlFor='propertyOptionId'
                          className={`block text-xs font-semibold text-gray-dark
                          }`}>
                          Property
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.propertyOptionId?.name}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-8 sm:col-span-3'>
                        <label
                          htmlFor='subPropertyOptionId'
                          className={`block text-xs font-semibold text-gray-dark
                          }`}>
                          Sub Property
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.subPropertyOptionId?.name}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      {enquiryServerData?.status === "ASSIGNED" && (
                        <div className='col-span-12 sm:col-span-12'>
                          <label
                            htmlFor='statusChangeRemarks'
                            className={`block text-sm font-semibold text-yellow
                          }`}>
                            Remarks (for Operations)
                          </label>
                          {enquiryServerData?.enquiryID ? (
                            <span className='block w-full py-0 pl-5 ml-3 text-sm font-semibold text-gray-800 '>
                              {enquiryServerData?.statusChangeRemarks}
                            </span>
                          ) : (
                            <span className='mt-1 block w-full py-0 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    <div className='mt-10 lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                          Additional Information
                        </h2>
                      </div>
                    </div>
                    <div className='mt-3 sm:mt-4 grid grid-cols-12 gap-6'>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='leadType'
                          className='block text-xs font-semibold text-gray-dark'>
                          Land Extent
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.landExtent &&
                              enquiryServerData?.landExtent +
                                " " +
                                enquiryServerData?.units}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='leadType'
                          className='block text-xs font-semibold text-gray-dark'>
                          Lead Type
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.leadType}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='channel'
                          className={`block text-xs font-semibold text-gray-dark
                          }`}>
                          Channel
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.channel}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      {["Reference", "Agent", "Others"].includes(
                        enquiryServerData?.channel,
                      ) ? (
                        <div className={`col-span-12 sm:col-span-3`}>
                          <label
                            htmlFor='referenceName'
                            className={`block text-xs font-semibold text-gray-dark
                            }`}>
                            {enquiryServerData?.channel === "Reference"
                              ? "Reference Name"
                              : enquiryServerData?.channel === "Agent"
                              ? "Agent Name"
                              : "Others"}
                          </label>
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.referenceName}
                          </span>
                        </div>
                      ) : enquiryServerData?.channel === "Website" ? (
                        <div className={`col-span-12 sm:col-span-3`}>
                          <label
                            htmlFor='websiteLink'
                            className={`block text-xs font-semibold text-gray-dark
                              }`}>
                            Website Link
                          </label>
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.websiteLink}
                          </span>
                        </div>
                      ) : (
                        <div className={`col-span-12 sm:col-span-3`} />
                      )}
                      {enquiryServerData?.subServiceTypeId?.name.toLowerCase() ===
                        "buy" && (
                        <div className={`col-span-12 sm:col-span-3`}>
                          <label
                            htmlFor='purposeOfBuying'
                            className={`block text-xs font-semibold text-gray-dark
                              }`}>
                            Purpose Of Buying
                          </label>
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.purposeOfBuying}
                          </span>
                        </div>
                      )}
                      <div className='col-span-6 sm:col-span-4'>
                        <label
                          htmlFor='leadType'
                          className='block text-xs font-semibold text-gray-dark'>
                          Location
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.location
                              ? enquiryServerData.location
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-4'>
                        <label
                          htmlFor='leadType'
                          className='block text-xs font-semibold text-gray-dark'>
                          Budget
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData.budget &&
                            enquiryServerData.budget > 0
                              ? getRefinedBudget(enquiryServerData.budget)[0] +
                                " " +
                                getBudgetFactor(
                                  getRefinedBudget(enquiryServerData.budget)[1],
                                ) +
                                " INR"
                              : "--"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-6 sm:col-span-1'>
                        <label
                          htmlFor='leadType'
                          className='block text-xs font-semibold text-gray-dark'>
                          BHK
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.bhk &&
                              enquiryServerData?.bhk + " BHK"}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-12 sm:col-span-6'>
                        <label
                          htmlFor='backgroundInformation'
                          className='block text-xs font-semibold text-gray-dark'>
                          Background Information
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.backgroundInformation}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-12 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='col-span-12 sm:col-span-6'>
                        <label
                          htmlFor='serviceInformation'
                          className='block text-xs font-semibold text-gray-dark'>
                          Service Information
                        </label>
                        {enquiryServerData?.enquiryID ? (
                          <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                            {enquiryServerData?.serviceInformation}
                          </span>
                        ) : (
                          <span className='mt-1 block w-full py-0  sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-full bg-gray-100 h-12 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                    </div>
                    {enquiryServerData.leadType === "Corporate" && (
                      <>
                        <div className='mt-5 lg:flex lg:items-center justify-between'>
                          <div className='flex-1 min-w-0 px-0 lg:px-0'>
                            <h2 className='text-lg font-semibold leading-3 text-gray-dark sm:text-lg '>
                              Corporate Lead Information
                            </h2>
                          </div>
                        </div>
                        <div className='mt-3 sm:mt-2 grid grid-cols-12 gap-6'>
                          <div className={`col-span-12 sm:col-span-3`}>
                            <label
                              htmlFor='corporateLeadCompanyName'
                              className={`block text-xs font-semibold text-gray-dark
                              }`}>
                              Company Name
                            </label>
                            <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                              {enquiryServerData?.corporateLeadDesignation
                                ? enquiryServerData?.corporateLeadDesignation +
                                  ", " +
                                  enquiryServerData?.corporateLeadCompanyName
                                : enquiryServerData?.corporateLeadCompanyName}
                            </span>
                          </div>
                          <div className={`col-span-12 sm:col-span-6`}>
                            <label
                              htmlFor='corporateLeadCompanyAddress'
                              className={`block text-xs font-semibold text-gray-dark
                              }`}>
                              Company Address
                            </label>
                            <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                              {enquiryServerData?.corporateLeadCompanyAddress}
                            </span>
                          </div>
                          <div className={`col-span-12 sm:col-span-3`}>
                            <label
                              htmlFor='corporateLeadPhone'
                              className={`block text-xs font-semibold text-gray-dark
                              }`}>
                              Company Phone
                            </label>
                            <span className='block w-full py-0 pl-5 ml-3 sm:text-sm'>
                              {enquiryServerData?.corporateLeadPhone}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    {enquiryServerData?.status?.toLowerCase() === "assigned" &&
                      state?.user?.department?.name?.toLowerCase() ===
                        "operations" && (
                        <div className='mt-10 bg-gray-50 p-4 rounded'>
                          <div className='min-w-0 px-0 lg:px-0'>
                            <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                              Move to{" "}
                              <span className='bg-green-100 text-green-800 text-sm font-semibold px-2.5 py-1 rounded dark:bg-green-200 dark:text-green-900'>
                                IN-PROCESS
                              </span>
                            </h2>
                          </div>
                          <div className='mt-4 grid grid-cols-12 gap-2  '>
                            <div className='col-span-12 sm:col-span-7'>
                              <label
                                htmlFor='closingComments'
                                className='block text-xs font-semibold text-gray'>
                                Closing Comments
                              </label>
                              <textarea
                                id='closingComments'
                                name='closingComments'
                                rows={4}
                                className='shadow-sm focus:ring-yellow-2 focus:border-yellow-2 mt-1 block w-full sm:text-xs border bg-gray-50 rounded-md'
                                placeholder=''
                                defaultValue={""}
                              />
                            </div>
                            <div className='col-span-12 sm:col-span-5'>
                              <label
                                htmlFor='closingAttachments'
                                className='block text-xs font-semibold text-gray'>
                                Closing Attachments
                              </label>
                              {isFileUploading ? (
                                <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer animate-bounce opacity-60'>
                                  <p className='p-3'>
                                    File Uploading to Server...
                                  </p>
                                </div>
                              ) : (
                                <FileUploader
                                  className='w-full'
                                  handleChange={uploadClosingAttachments}
                                  name='file'
                                  multiple={true}
                                  label='Upload or Drop files to move enquiry to Service ticket'
                                  children={
                                    <div className='rounded w-full h-24 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer'>
                                      <p className=''>
                                        Drag &amp; Drop files here
                                      </p>
                                    </div>
                                  }
                                  types={["JPG", "PNG", "PDF"]}
                                />
                              )}
                            </div>
                            <div className='col-span-12 sm:col-span-7'>
                              <div className='grid grid-cols-2 gap-2'>
                                {closingAttachments.length > 0 ? (
                                  closingAttachments.map((item) => (
                                    <div
                                      key={item.filename}
                                      className='my-2 mr-1 px-1.5 py-1 bg-white rounded z-0'>
                                      <div className='flex'>
                                        <div className='font-semibold text-yellow-dark mt-0.25 text-xs'>
                                          {item.originalname}
                                        </div>
                                        <div
                                          className='ml-2 cursor-pointer'
                                          onClick={(e) => {
                                            e.preventDefault();
                                            removeClosingAttachment(
                                              item.filename,
                                            );
                                          }}>
                                          <img
                                            className={`h-4 w-4`}
                                            src='/assets/icons/trash-filled.png'
                                            alt='Delete'
                                            title='Remove attachment'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className='px-3 py-2'>
                                    <h4 className='text-lg font-semibold'>
                                      No attachments
                                    </h4>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className='col-span-12 sm:col-span-5 '>
                              {!requestLoading ? (
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    createServiceTicket();
                                  }}
                                  className='ml-2 py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                                  Move to Service
                                </button>
                              ) : (
                                <button
                                  className='animate-bounce inline-flex items-center px-6 py-2 rounded-sm text-sm font-medium text-white bg-yellow-2 hover:bg-gray-dark hover:text-white focus:outline-none ml-2 mt-5'
                                  disabled={true}>
                                  Processing...
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    {enquiryServerData?.taggedPif?.length > 0 && (
                      <>
                        <label
                          htmlFor='backgroundInformation'
                          className='block text-xs font-semibold text-gray-dark'>
                          Tagged Properties
                        </label>
                        <div className='pt-4 grid grid-cols-12 gap-5'>
                          {enquiryServerData?.taggedPif.map((item, index) => (
                            <div
                              key={item._id}
                              onClick={(e) => {
                                navigate("/property/" + item._id);
                              }}
                              className='relative flex-col col-span-5 sm:col-span-2 pt-0 bg-yellow-50 hover:border-yellow-dark duration-300 cursor-default border-gray-50 shadow-sm hover:shadow-xl hover:shadow-yellow-3 opacity-90 hover:opacity-100 '>
                              <div className='justify-center max-h-56 bg-yellow-dark overflow-hidden '>
                                <PropertyThumbnail
                                  key={item.blobName}
                                  thumbnail={item.thumbnail}
                                  isthumbnail={true}
                                />
                              </div>
                              <div className='absolute bottom-0 left-0 bg-yellow-light bg-opacity-100 w-full duration-300'>
                                <div className='flex flex-col'>
                                  <div className=' px-4 py-2'>
                                    <div className='flex justify-between'>
                                      <span className='text-sm font-semibold text-gray-dark'>
                                        Service #
                                        {item.serviceTicketId.serviceTicketID}
                                      </span>
                                    </div>
                                    <div className='flex-col'>
                                      <div className='-mt-1'>
                                        <span className='pt-0 text-xs font-semibold text-gray-dark w-full leading-3'>
                                          {numberToINR(item.price)}
                                        </span>
                                      </div>
                                      <div className='mt-1'>
                                        <p className='pt-0 text-xs font-normal  text-gray-dark w-full leading-normal'>
                                          {transformAddress(item)}
                                          {item.pincode
                                            ? "- " + item.pincode
                                            : ""}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className='flex justify-center w-full bg-yellow-2 duration-300 hover:bg-yellow-dark cursor-pointer py-2.5'
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      untagProperty(index);
                                    }}>
                                    <span className='text-sm font-medium'>
                                      Untag
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                  {enquiryServerData?.serviceTypeId?._id ===
                    "632e9b76b10c8102926ba9be" &&
                    enquiryServerData?.subServiceTypeId?._id ===
                      "6364ad0a314cd73283ec1a7f" && (
                      <PropertyTagging enquiryItem={enquiryServerData} />
                    )}
                  {((enquiryServerData?.serviceTypeId?.name
                    ?.toLowerCase()
                    .includes("brokerage") &&
                    enquiryServerData?.subServiceTypeId?.name
                      ?.toLowerCase()
                      .includes("sell")) ||
                    (enquiryServerData?.serviceTypeId?.name
                      ?.toLowerCase()
                      .includes("rental") &&
                      enquiryServerData?.subServiceTypeId?.name
                        ?.toLowerCase()
                        .includes("landlord"))) && (
                    <div className='px-2 sm:px-5'>
                      <div className='mt-10 lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Property Information
                          </h2>
                        </div>
                      </div>
                      <div className='grid mt-2 grid-cols-12 gap-2'>
                        <div className='col-span-12 rounded-md'>
                          {enquiryServerData?.pifLat ? (
                            <GmapsComponent
                              zoom={10}
                              position={markerCoordinates}
                              draggableMarker={false}
                            />
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='frontage'
                            className='block text-xs font-medium text-gray-700'>
                            Frontage
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {enquiryServerData?.pifFrontage
                              ? enquiryServerData?.pifFrontage
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='pifLocations'
                            className={`block text-xs font-medium `}>
                            Tagged Locations
                          </label>
                          <div className='mt-1 w-full py-0 pl-5 flex gap-2'>
                            {enquiryServerData?.pifLocations &&
                            enquiryServerData?.pifLocations.length > 0 ? (
                              enquiryServerData.pifLocations.map((item) => (
                                <span className='px-2 py-1 text-white text-sm font-normal bg-yellow-dark rounded-sm'>
                                  {item.name}
                                </span>
                              ))
                            ) : (
                              <span className='px-2 py-1 text-sm font-semibold bg-yellow-2 rounded-sm'>
                                No Locations Tagged
                              </span>
                            )}
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='facing'
                            className='block text-xs font-medium text-gray-700'>
                            Facing
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {enquiryServerData?.pifFacing
                              ? enquiryServerData?.pifFacing
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='buildingFloors'
                            className='block text-xs font-medium text-gray-700'>
                            Building Floors
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {enquiryServerData?.pifBuildingFloors
                              ? enquiryServerData?.pifBuildingFloors
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-4 sm:col-span-2 pt-2'>
                          {enquiryServerData?.pifParkingAvailable && (
                            <span className='bg-gray-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                              PARKING AVAILABLE
                            </span>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-10'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Property Images
                          </label>
                          <div className='grid grid-cols-6 gap-4'>
                            {propertyImageAttachments.length > 0 ? (
                              propertyImageAttachments.map((item) => (
                                <div
                                  className='col-span-3 sm:col-span-1 flex justify-center'
                                  key={item.blobName}>
                                  <PropertyThumbnail thumbnail={item} />
                                </div>
                              ))
                            ) : (
                              <div className='ml-4 mt-1 text-sm font-medium'>
                                None added yet
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className='col-span-12 sm:col-span-10 sm:pl-5 pl-2 pr-2 sm:w-9/12'>
                    <h2 className='text-sm sm:text-lg font-semibold leading-3 text-gray-dark sm:mt-4 mt-0'>
                      Activity
                    </h2>
                    <div className='my-2 p-0 pt-1 pb-0 flex'>
                      <div className='p-1'>
                        {enquiryServerData?.validflag === 1 &&
                          (enquiryServerData?.enquiryID ? (
                            <img
                              src={
                                state?.user?.avatar
                                  ? state?.user?.avatar
                                  : "/assets/images/user.png"
                              }
                              alt='User'
                              referrerPolicy='no-referrer'
                              className='h-8 w-8 rounded-full '
                            />
                          ) : (
                            <div className='animate-pulse w-8 bg-gray-300 h-8 rounded-full'></div>
                          ))}
                      </div>
                      {enquiryServerData?.validflag === 1 &&
                        (enquiryServerData?.enquiryID ? (
                          <div className='flex-row overflow-x-auto px-3 rounded-lg py-3 bg-gray-100 w-11/12'>
                            <form
                              action='#'
                              method='POST'
                              id='enquiryCommentForm'
                              noValidate
                              onSubmit={(event) => {
                                event.preventDefault();
                                postComment(event);
                              }}>
                              <div className='text-sm font-semibold py-0.25 text-blue-800 '>
                                <input
                                  type='text'
                                  name='commentTags'
                                  id='commentTags'
                                  maxLength='50'
                                  placeholder='Tags can be split using spacebar'
                                  className={`mt-0 focus:ring-yellow-2 focus:border-yellow-2 block sm:w-6/12 w-full shadow-sm text-xs border-0 bg-yellow-50 py-1 px-2 rounded-sm`}
                                />
                              </div>
                              <textarea
                                name='commentDescription'
                                id='commentDescription'
                                rows={4}
                                placeholder='Write Comments here..'
                                className={`mt-1 w-full border-0 bg-gray-50 ${
                                  !validCommentDescription
                                    ? "border ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                    : "focus:ring-yellow-2 focus:border-yellow-2"
                                }  block shadow-sm sm:text-sm  rounded-md`}
                              />
                              {!validCommentDescription && (
                                <p className='text-red-600 text-sm font-semibold'>
                                  Comment invalid
                                </p>
                              )}
                              <div className='flex'>
                                {commentAttachments.length > 0 ? (
                                  commentAttachments.map((item) => (
                                    <div
                                      key={item.filename}
                                      className='my-2 mr-1 px-1.5 py-1 pt-0.5 bg-white rounded z-0'>
                                      <div className='flex'>
                                        <div className='font-semibold text-xs text-yellow-dark mt-1'>
                                          {item.originalname}
                                        </div>
                                        <div
                                          className='ml-2 pt-1 cursor-pointer'
                                          onClick={(e) => {
                                            e.preventDefault();
                                            removeCommentAttachment(
                                              item.originalname,
                                            );
                                          }}>
                                          <img
                                            className={`h-4 w-4`}
                                            src='/assets/icons/trash-filled.png'
                                            alt='X'
                                            title='Remove attachment'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className=''>
                                {isFileUploading ? (
                                  <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer animate-bounce opacity-60'>
                                    <p className='p-3'>
                                      File Uploading to Server...
                                    </p>
                                  </div>
                                ) : (
                                  <FileUploader
                                    handleChange={uploadCommentAttachments}
                                    name='attachments'
                                    multiple={true}
                                    label='Upload or Drop files to move enquiry to Service ticket'
                                    children={
                                      <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer'>
                                        <p className='p-3'>
                                          Drag &amp; Drop files here
                                        </p>
                                      </div>
                                    }
                                    types={["JPG", "PNG", "PDF", "TXT"]}
                                  />
                                )}
                              </div>
                              <div className='ml-0 pb-1'>
                                {!requestLoading ? (
                                  <button
                                    id='submitBtn'
                                    type='submit'
                                    className='mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                                    Add Activity
                                  </button>
                                ) : (
                                  <button
                                    className='animate-bounce mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                                    disabled={true}>
                                    Processing...
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-2 sm:text-base'>
                            <div className='flex animate-pulse flex-col h-full '>
                              <div className='w-6/12 bg-yellow-50 h-6 rounded-md '></div>
                              <div className='mt-3 w-10/12 bg-gray-100 h-20 rounded-md '></div>
                              <div className='mt-3 w-32 bg-yellow-2 h-12 rounded-md '></div>
                            </div>
                          </span>
                        ))}
                    </div>
                    <div className='mt-1 '>
                      {enquiryServerData?.enquiryID ? (
                        enquiryCommentsData?.length > 0 ? (
                          enquiryCommentsData.map((item) => (
                            <div className='flex-col ml-7'>
                              <div
                                key={item._id}
                                className='mt-2 p-2 pt-1 pb-0 flex justify-start'>
                                <div className='flex-row overflow-x-auto pl-2 pr-5 rounded-lg py-2 bg-gray-300 peer'>
                                  <div className='flex'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      referrerPolicy='no-referrer'
                                      className='h-6 w-6 rounded-full '
                                    />
                                    <div className='ml-1 mt-0.5 text-sm font-semibold'>
                                      {item.createdBy.firstname} &bull;{" "}
                                      {format(
                                        new Date(item.createdAt),
                                        "MMM dd yyyy, hh:mm a",
                                      )}
                                    </div>
                                  </div>
                                  <div className='text-xs font-semibold pt-1 pb-0.25 text-blue-800 mt-1'>
                                    <p className='text-shadow'>
                                      {item.tags && item.tags !== ""
                                        ? renderTags(item.tags)
                                        : item.commentType !== "user-comment"
                                        ? renderTags(item.commentType)
                                        : ""}
                                    </p>
                                  </div>
                                  <div
                                    className='text-sm'
                                    dangerouslySetInnerHTML={{
                                      __html: item.description,
                                    }}></div>
                                </div>
                                {state.user._id === item.createdBy._id &&
                                  item.commentType === "user-comment" &&
                                  moment(item?.createdAt).diff(
                                    Date.now(),
                                    "minutes",
                                  ) > -10 && (
                                    <div className='peer-hover:opacity-100 opacity-0 hover:opacity-100'>
                                      <div
                                        className='mt-0 ml-1 p-0.5 rounded bg-yellow-dark cursor-pointer'
                                        onClick={(e) => {
                                          e.preventDefault();
                                          removeActivity(item._id);
                                        }}>
                                        <img
                                          className={`h-5 w-5`}
                                          src='/assets/icons/trash-filled.png'
                                          alt='Delete'
                                          title='Delete Activity'
                                        />
                                      </div>
                                    </div>
                                  )}
                              </div>
                              <div className='flex w-full overflow-x-auto'>
                                {item.attachments?.length > 0 ? (
                                  item.attachments.map((item) => (
                                    <div
                                      key={item.blobName}
                                      className={`mt-1 ml-1.5 text-xs px-1.5 pt-0.5 pb-1 rounded-md z-0  `}>
                                      <div
                                        className={`font-semibold bg-yellow-50  text-yellow-dark p-2 rounded-sm ${
                                          item.blobName === downloadBlobFileName
                                            ? "animate-pulse cursor-wait"
                                            : "cursor-pointer"
                                        }`}
                                        onClick={(e) => {
                                          // downloadAttachment(
                                          //   item.blobContainer,
                                          //   item.blobName,
                                          //   item.originalname,
                                          //   item.mimetype,
                                          // );
                                          downloadAttachment(
                                            item.bucket,
                                            item.blobName,
                                            item.originalname,
                                            item.contentType,
                                          );
                                        }}>
                                        {item.originalname}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className='w-full grid justify-items-center font-semibold mt-4 text-base'>
                            No Activity yet
                          </div>
                        )
                      ) : (
                        <span className='mt-4 block w-full py-0 pl-5 sm:text-base'>
                          <div className='flex animate-pulse flex-col h-full '>
                            <div className='w-10/12 bg-gray-100 h-12 rounded-md '></div>
                            <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                            <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                            <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                          </div>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                    <div className='lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                          }}
                          className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-semibold rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                          Back
                        </button>
                        {(state.user.department?.name === "CRM" ||
                          state.user?.aclGroup === "super-admin" ||
                          state.user._id ===
                            enquiryServerData?.createdBy?._id) &&
                          enquiryServerData?.status?.toLowerCase() ===
                            "new" && (
                            <button
                              id='submitBtn'
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(
                                  "/enquiry/edit/" + enquiryServerData._id,
                                );
                              }}
                              className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                              Edit
                            </button>
                          )}
                      </div>
                    </div>
                    <div className='sm: py-2'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default EnquiryIndividual;
